let firebaseConfig = {
  apiKey: "AIzaSyAtNo98U0ZB4cgEDa0iL7XtnB_PlL6Q_D0",
  authDomain: "my-im-in-dev.firebaseapp.com",
  databaseURL: "https://my-im-in-dev.firebaseio.com",
  projectId: "my-im-in-dev",
  storageBucket: "my-im-in-dev.appspot.com",
  messagingSenderId: "503481217113",
  appId: "1:503481217113:web:b873a28550020119470148",
  measurementId: "G-5N1RVDF7NE"
};

if(IS_PRODUCTION) {
// Your web app's Firebase configuration
  firebaseConfig = {
    apiKey: "AIzaSyCmdsa5Ysb_28DiTr89gI7ffQg7HH_dsvs",
    authDomain: "my-im-in.firebaseapp.com",
    databaseURL: "https://my-im-in.firebaseio.com",
    projectId: "my-im-in",
    storageBucket: "my-im-in.appspot.com",
    messagingSenderId: "410714061617",
    appId: "1:410714061617:web:1f7b400ea9afed826f8e10",
    measurementId: "G-B5LXYQ2J1S"
  };
}

export {firebaseConfig};